export enum NotificationSettingsFrequency {
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
}
